var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gh-page gh-page-summit",attrs:{"sticky-container":""}},[_c('gh-form-upgrade',{staticClass:"bg-pale-grey"}),_vm._v(" "),_c('gh-sponsors',{staticClass:"bg-white",attrs:{"optionalStyle":'background-color: white;'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }